<template>
  <div>
    <div>
      <el-row :gutter="24">
        <el-col :span="4">
          <el-input placeholder="商家id" v-model="params.merchant_id" style="width: 100%" size="mini"> </el-input>
        </el-col>
        <el-col :span="4">
          <el-input placeholder="商家名称" v-model="params.name" style="width: 100%" size="mini">
          </el-input>
        </el-col>
        <el-col :span="7">
          <el-button type="primary" @click="searchData" size="mini">搜索</el-button>
        </el-col>
      </el-row>
      <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
        <el-table-column prop="merchant_id" label="商家id"></el-table-column>
        <el-table-column prop="name" label="商家名称"></el-table-column>
        <el-table-column prop="allAmount" label="总额"></el-table-column>
        <el-table-column prop="freezenAmount" label="冻结额"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="getDetail(scope.row)">在途资金明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="content-center content-top-padded">
        <el-pagination background layout="total, sizes, prev, pager, next" @current-change="handleCurrentChange"
          @size-change="handleSizeChange" :current-page.sync="params.page" :page-sizes="[10, 20, 50]"
          :total="total_count" :page-size="params.pagesize">
        </el-pagination>
      </div>
      <el-dialog :title="title" :visible.sync="dialogVisible">
        <el-table :data="moneyList">
          <el-table-column property="orderNo" label="托管代收订单号"></el-table-column>
          <el-table-column property="collTime" label="代收时间"></el-table-column>
          <el-table-column property="payerId" label="付款人id"></el-table-column>
          <el-table-column property="recieverName" label="收款人姓名"></el-table-column>
          <el-table-column property="recieverId" label="收款人"></el-table-column>
          <el-table-column property="managedCollAmount" label="托管代收金额">
            <template slot-scope="scope">
              {{(scope.row.managedCollAmount / 100) .toFixed(2)}} </template>
          </el-table-column>
          <el-table-column property="estCollAmount" label="预计收款金额">
            <template slot-scope="scope"> {{(scope.row.estCollAmount / 100) .toFixed(2)}} </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters
  } from "vuex";
  import draggable from "vuedraggable";
  import {
    getBalanceList,
    getPayeeFundsInTransitDetail
  } from "../../../api/merchant";
  export default {
    components: {
      draggable
    },
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        dialogVisible: false,
        total_count: 0,
        params: {
          page: 1,
          pagesize: 20,
        },
        dataList: [],
        loading: false,
        id: "",
        row: [],
        moneyList: [],
        title: '',
      };
    },
    computed: {
      ...mapGetters(["wheight"]),
    },
    methods: {
      getDetail(row) {

        this.row = row;
        this.title = row.name;
        this.dialogVisible = true;
        getPayeeFundsInTransitDetail({
          merchant_id: row.merchant_id
        }).then((res) => {
          if (res.data.data.status == true) {
            this.moneyList = res.data.data.data
          }
        })
      },
      getDataList() {
        this.loading = true;
        getBalanceList(this.params)
          .then((response) => {
            this.dataList = response.data.data.list;
            this.total_count = response.data.data.total_count;
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            this.$message({
              type: "error",
              message: "获取列表信息出错",
            });
          });
      },
      handleCurrentChange(page_num) {
        this.params.page = page_num;
        this.getDataList();
      },
      searchData() {
        this.params.page = 1;
        this.getDataList();
      },
      handleSizeChange(pageSize) {
        this.params.page = 1;
        this.params.pagesize = pageSize;
        this.getDataList();
      },
      show(row) {
        this.dialogFormVisible = true;
        this.row = row;
      },
      //export
    },
    mounted() {

      this.getDataList();

    },
  };
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      width: 90%;
    }
  }

  .el-col {
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// merchantbanlance.vue?15ad1244